import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DynReport8Component } from './dyn-report/dyn-report8.component';
import { DynReport9Component } from './dyn-report/dyn-report9.component';
import { DynReport9AComponent } from './dyn-report/dyn-report9A.component';
import { DynReport10Component } from './dyn-report/dyn-report10.component';
import { DynReport11AComponent } from './dyn-report/dyn-report11A.component';
import { DynReport11APComponent } from './dyn-report/dyn-report11AP.component';
import { DynReport17AComponent } from './dyn-report/dyn-report17A.component';
import { DynReport11PComponent } from './dyn-report/dyn-report11P.component';


import { DynReportListComponent } from './dyn-report-list/dyn-report-list.component';
import { DynReportsComponent } from './dyn-reports.component';

const routes: Routes = [
  {
    path: '',
    component: DynReportsComponent,
    children: [
      {
        path: '',
        component: DynReportListComponent
      },
      {
        path: 'IZVESTAJ_8',
        component: DynReport8Component
      },
      {
        path: 'IZVESTAJ_9',
        component: DynReport9Component
      },
      {
        path: 'IZVESTAJ_9A',
        component: DynReport9AComponent
      },
      {
        path: 'IZVESTAJ_10',
        component: DynReport10Component
      },
      {
        path: 'IZVESTAJ_11A',
        component: DynReport11AComponent
      },
      {
        path: 'IZVESTAJ_11AP',
        component: DynReport11APComponent
      },
      {
        path: 'IZVESTAJ_11P',
        component: DynReport11PComponent
      },
      {
        path: 'IZVESTAJ_17A',
        component: DynReport17AComponent
      }
    ]
  },
  // { path: '', component: HeaderComponent, outlet: 'header' },
  // { path: '', component: FooterComponent, outlet: 'footer' }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})

export class DynReportsRoutingModule { }

export const routedComponents = [DynReportsComponent, DynReportListComponent, DynReport8Component, DynReport9Component,
  DynReport9AComponent, DynReport10Component, DynReport11AComponent, DynReport11APComponent, DynReport11PComponent, DynReport17AComponent];



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-reports-routing.module.ts